export function Helpers (pConfig)
{
  this.editorToolbarConfigRenderer = (inConfig, template) =>
  {
    let k,
        i,
        lenI = template.Groups.length,
        j,
        lenJ = inConfig.Groups.length,
        outConfig = {};

    for (k in inConfig)
    {
      if (inConfig.hasOwnProperty(k) && typeof(inConfig[k]) !== 'object' && !Array.isArray(inConfig[k]) && typeof(inConfig[k]) !== 'function')
      {
        outConfig[k] = inConfig[k];
      }
    }

    outConfig.Groups = [];

    for (i = 0; i < lenI; i++)
    {
      for (j = 0; j < lenJ; j++)
      {
        if (inConfig.Groups[j].name === template.Groups[i].name)
        {
          outConfig.Groups[i] = inConfig.Groups[j];

          if (template.Groups[i].visible != null)
          {
            outConfig.Groups[i].visible = template.Groups[i].visible;
          }

          if (template.Groups[i].isDropdown != null)
          {
            outConfig.Groups[i].isDropdown = template.Groups[i].isDropdown;
          }

          if (template.Groups[i].lineBreak)
          {
            outConfig.Groups[i].lineBreak = true;
          }
        }
      }
    }

    return outConfig;
  };


  this.editorToolbarConfigCopier = (inConfig, outConfig) =>
  {
    outConfig.Groups = [];

    for (let i = 0; i < inConfig.Groups.length; i++)
    {
      outConfig.Groups[i] = {};
      outConfig.Groups[i].name = inConfig.Groups[i].name;

      if (outConfig.GroupsChange && outConfig.GroupsChange[outConfig.Groups[i].name])
      {
        outConfig.Groups[i].visible = outConfig.GroupsChange[outConfig.Groups[i].name].visible;

        if (outConfig.GroupsChange[outConfig.Groups[i].name].isDropdown)
        {
          outConfig.Groups[i].isDropdown = true;
        }

        if (outConfig.GroupsChange[outConfig.Groups[i].name].lineBreak)
        {
          outConfig.Groups[i].lineBreak = true;
        }

        outConfig.Groups[i].sepSizeWidth = outConfig.GroupsChange[outConfig.Groups[i].name].sepSizeWidth;
      }
      else
      {
        outConfig.Groups[i].visible = inConfig.Groups[i].visible;

        if (inConfig.Groups[i].isDropdown)
        {
          outConfig.Groups[i].isDropdown = true;
        }

        if (inConfig.Groups[i].lineBreak)
        {
          outConfig.Groups[i].lineBreak = true;
        }
      }
    }
  };


  this.editorToolbarButtonsConfigParser = (toolbar) =>
  {
    let k,
        i,
        n,
        len,
        key,
        btnFileName,
        btnFileURL,
        buttons = {};

    for (k in pConfig.resources.sprites)
    {
      if (pConfig.resources.sprites.hasOwnProperty(k))
      {
        pConfig.resources.sprites[k].icoOffsetX = 0;

        for (i = 0, len = pConfig.resources.sprites[k].icons.length; i < len; i++)
        {
          pConfig.resources.spritesHash[k + '_' + pConfig.resources.sprites[k].icons[i].name] = pConfig.resources.sprites[k].icons[i];
          pConfig.resources.sprites[k].icons[i].spriteName = k;
          pConfig.resources.sprites[k].icons[i].icoOffsetX = pConfig.resources.sprites[k].icoOffsetX;
          pConfig.resources.sprites[k].icoOffsetX += pConfig.resources.sprites[k].icons[i].width;
        }

        pConfig.resources.sprites[k].spriteWidth = pConfig.resources.sprites[k].icoOffsetX;
      }
    }

    if (!('btnFileName' in toolbar))
    {
      toolbar.btnFileName = null;
    }

    if (!('btnFileURL' in toolbar) && toolbar.btnFileName !== null)
    {
      toolbar.btnFileURL = pConfig.resources.sprites[toolbar.btnFileName].url;
    }

    for (i = toolbar.Groups.length; i--;)
    {
      btnFileName = toolbar.btnFileName;
      btnFileURL = toolbar.btnFileURL;

      if ('btnFileURL' in toolbar.Groups[i])
      {
        btnFileURL = toolbar.Groups[i].btnFileURL;
        toolbar.Groups[i].btnFileName = null;
      }
      else if ('btnFileName' in toolbar.Groups[i])
      {
        btnFileURL = pConfig.resources.sprites[toolbar.Groups[i].btnFileName].url;
        toolbar.Groups[i].btnFileURL = btnFileURL;
      }
      else
      {
        toolbar.Groups[i].btnFileURL = btnFileURL;

        if (btnFileName !== null)
        {
          toolbar.Groups[i].btnFileName = btnFileName;
        }
      }

      for (n = toolbar.Groups[i].Buttons.length; n--;)
      {
        btnFileName = toolbar.Groups[i].btnFileName;
        btnFileURL = toolbar.Groups[i].btnFileURL;

        if ('btnFileURL' in toolbar.Groups[i].Buttons[n])
        {
          btnFileURL = toolbar.Groups[i].Buttons[n].btnFileURL;
          toolbar.Groups[i].Buttons[n].btnFileName = null;
        }
        else if ('btnFileName' in toolbar.Groups[i].Buttons[n])
        {
          btnFileURL = pConfig.resources.sprites[toolbar.Groups[i].Buttons[n].btnFileName].url;
          toolbar.Groups[i].Buttons[n].btnFileURL = btnFileURL;
        }
        else
        {
          toolbar.Groups[i].Buttons[n].btnFileURL = btnFileURL;

          if (btnFileName !== null)
          {
            toolbar.Groups[i].Buttons[n].btnFileName = btnFileName;
          }
        }

        if (btnFileName !== null)
        {
          key = btnFileName + '_' + (('iconName' in toolbar.Groups[i].Buttons[n]) ? toolbar.Groups[i].Buttons[n].iconName : toolbar.Groups[i].Buttons[n].name);

          if (!('btnFileWidth' in toolbar.Groups[i].Buttons[n]))
          {
            toolbar.Groups[i].Buttons[n].btnFileWidth = pConfig.resources.sprites[pConfig.resources.spritesHash[key].spriteName].spriteWidth;
          }

          if (!('btnFileHeight' in toolbar.Groups[i].Buttons[n]))
          {
            toolbar.Groups[i].Buttons[n].btnFileHeight = pConfig.resources.sprites[pConfig.resources.spritesHash[key].spriteName].spriteHeight;
          }

          if (!('btnSizeWidth' in toolbar.Groups[i].Buttons[n]))
          {
            toolbar.Groups[i].Buttons[n].btnSizeWidth = pConfig.resources.spritesHash[key].width;
          }

          if (!('btnSizeHeight' in toolbar.Groups[i].Buttons[n]))
          {
            toolbar.Groups[i].Buttons[n].btnSizeHeight = pConfig.resources.sprites[pConfig.resources.spritesHash[key].spriteName].buttonHeight;
          }

          if (!('icoOffsetX' in toolbar.Groups[i].Buttons[n]))
          {
            toolbar.Groups[i].Buttons[n].icoOffsetX = pConfig.resources.spritesHash[key].icoOffsetX;
          }
        }

        if (toolbar.Groups[i].Buttons[n].type !== 'LinkToExistingButton')
        {
          buttons[toolbar.Groups[i].Buttons[n].name] = toolbar.Groups[i].Buttons[n];
        }
      }
    }

    for (i = toolbar.Groups.length; i--;)
    {
      for (n = toolbar.Groups[i].Buttons.length; n--;)
      {
        if (toolbar.Groups[i].Buttons[n].type === 'LinkToExistingButton')
        {
          for (k in buttons[toolbar.Groups[i].Buttons[n].name])
          {
            if (buttons[toolbar.Groups[i].Buttons[n].name].hasOwnProperty(k))
            {
              toolbar.Groups[i].Buttons[n][k] = buttons[toolbar.Groups[i].Buttons[n].name][k];
            }
          }
        }
      }
    }
  };
}